import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Shell";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-background" data-testid="payment-cancel">
      <div className="max-w-md w-full text-center space-y-6">
        <LogoMark className="h-10 w-10 mx-auto" />
        <h1 className="font-display text-3xl">No charge was made.</h1>
        <p className="text-sm text-muted-foreground">You left checkout before paying. Your credits and work are exactly as you left them.</p>
        <div className="flex justify-center gap-3"><Link to="/billing" className="btn-outline" data-testid="cancel-back-billing">Back to billing</Link><Link to="/home" className="btn-gold" data-testid="cancel-back-home">Home</Link></div>
      </div>
    </div>
  );
}
